// extracted by mini-css-extract-plugin
export default {"root":"oVYNnW","line":"Yf7bQV"};